export const initialState = {
  isAuth: false,
  isBanned: false,
  notifications: [],
  // isCashbackActive: false,
};
